var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background":"#555"}},[_c('v-main',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('router-view')],1)],1)],1),_c('portal-target',{attrs:{"name":"v-app","multiple":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }